import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const UserStyles: moduleStyleType = {
    searchResults: {
        width: '100%',
        borderRadius: '6px',
        backgroundColor: 'background.default',
        '& .MuiGridLegacy-container .MuiGridLegacy-item': {
            padding: 1,
            '&:hover': {
                cursor: 'pointer',
                backgroundColor: 'grey.200',
            },
        },
    },
    autoWidth: {
        '& .MuiGridLegacy-item': {
            width: 'auto',
        },
    },
    hand: {
        cursor: 'pointer',
    },
    empty: {
        '& .MuiTypography-root': {
            color: 'text.secondary',
            fontWeight: 450,
        },
    },
    expandableUserListContainer: {
        display: 'flex',
        alignItems: 'center',
        maxWidth: '30ch',
    },
    userList: {
        marginRight: 1,
    },
}
